module.exports = __webpack_public_path__ + "media/img/illustrations/happiness-fbbc3bb4d37a37c3f7f8d6352ad69633.svg";